<template>
  <div class="address-list">
    <i class="line"></i>
    <van-empty v-if="list.length == 0" image="https://xhdata.wan4.com/wsw-h5-38.png" description="没有收货地址！" />
    <template v-else>
      <div class="item-box" v-for="item, index in list" :key="index">
        <span class="name">{{ item.cname }}/{{ item.cmobile }}</span>
        <span class="address">{{ item.daddr }}{{ item.daddr2 }}</span>
        <span class="default-opt" :class="{ 'default-opt-on': item.dflag == 1 }"
          @click="setDefaultAddress(item)">{{ item.dflag == 1 ? '默认收货地址' : '设为默认' }}</span>
        <i class="icon-edit" @click="edit(item)">编辑</i>
        <span class="del-btn" @click="del(item, index)">删除</span>
      </div>
    </template>



    <!-- 添加 -->
    <div class="bottom-btn-box">
      <van-button class="add-btn" icon="https://xhdata.wan4.com/wsw-h5-39.png" type="primary"
        @click="editItem = {}, showEditAddress = true">添加收货地址</van-button>
    </div>

    <editAddressPopup v-model="showEditAddress" :data="editItem" @onFinish="getData()"></editAddressPopup>
  </div>
</template>

<script>
import editAddressPopup from '../../components/editAddressPopup.vue';
export default {
  name: 'AddressList',
  data() {
    return {
      showEditAddress: false,
      editItem: {},
      list: [],
    }
  },
  created() {
    this.getData();
  },
  components: {
    editAddressPopup
  },
  methods: {
    getData() {
      this.$ajax('/iap-api/wan4/addressbook/query.do', { seq: 0 }).then(res => {
        this.list = res.data || [];
      })
    },
    del(item, index) {
      this.$dialog.confirm({
        message: `确定 <span style='font-weight: bold;'>删除收货地址</span> 吗?`
      }).then(() => {
        this.$ajax('/iap-api/wan4/addressbook/del.do', { seq: item.seq }).then(() => {
          if (item.dflag == 1) {
            this.getData()
          } else {
            this.list.splice(index, 1);
          }
        })
      }).catch(() => {
      });
    },
    edit(item) {
      item.daddr = item.daddr + item.daddr2;
      this.editItem = item;
      this.showEditAddress = true;
    },
    setDefaultAddress(item) {
      if (item.dflag == 1) {
        return
      }
      item.dflag = 1;
      this.$ajax('/iap-api/wan4/addressbook/amend.do', item).then(() => {
        this.list.forEach(e => {
          e.dflag = e.seq == item.seq ? 1 : 0
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.address-list {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 100%;
  margin-bottom: calc(env(safe-area-inset-bottom) + 145px);


  .line{
    width: 100vw;
    height: 1px;
    background: #DCDCDC;
    position: fixed;
    top: 88px;
  }
  .item-box {
    display: flex;
    flex-direction: column;
    margin: 0 32px;
    padding: 32px 0 24px;
    position: relative;

    &::after {
      position: absolute;
      bottom: -1px;
      right: 0;
      left: 0;
      content: '';
      height: 1px;
      background: #E5E6EB;
    }

    .name {
      color: #333;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;
    }

    .address {
      color: #666;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      margin-top: 12px;
      word-break: break-all;
      margin-right: 50px;
    }

    .icon-edit {
      position: absolute;
      right: -28px;
      width: 94px;
      height: 94px;
      font-size: 0;
      top: 50%;
      transform: translateY(-50%);
      background: url('https://xhdata.wan4.com/wsw-h5-40.png') no-repeat center;
      background-size: 38px 38px;
    }

    .del-btn {
      border-radius: 4px;
      border: 1px solid #DCDCDC;
      background: #F4F4F4;
      width: 96px;
      height: 42px;
      color: #999;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
      position: absolute;
      bottom: 24px;
      right: 0;
      z-index: 1;
    }

    .default-opt {
      color: #999;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      display: flex;
      align-items: center;
      margin: 18px 0 0;

      &::before {
        content: '';
        border: 2px solid #999;
        width: 28px;
        height: 28px;
        border-radius: 28px;
        margin-right: 6px;
      }

      &-on {
        color: #FF6634;

        &::before {
          content: '';
          border: none;
          width: 32px;
          height: 32px;
          background: url('https://xhdata.wan4.com/wsw-h5-21.png') no-repeat center;
          background-size: 100%;
          border-radius: 32px;
          margin-right: 6px;
        }
      }
    }
  }

  .bottom-btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    z-index: 2;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.12);
    padding: 16px 0;
    padding-bottom: calc(env(safe-area-inset-bottom) + 16px);

    .van-button {
      margin: auto 24px;
      width: 100%;
      border-radius: 8px;
      font-size: 34px;
      font-weight: bold;
      color: #fff;
      height: 88px;
    }
  }

}
</style>
